import tripActions from '../actions/tripActions';
import createReducer from '../utils/createReducer';
import TripRecord from '../records/tripRecord';

const initialState = new TripRecord();

const actionHandlers = {
    [tripActions.UPDATE_TRIP_DETAILS](state, {payload = {}}) {
        const {fieldsChanged} = payload;

        return state.merge(fieldsChanged);
    }
};

export default createReducer(actionHandlers, initialState);
